export const clientTypesMap = {
  client: 1,
  supplier: 2,
  both: 3,
};

export const clientCodeTypesMap = {
  company: 1,
  personal: 2,
};

export const accountingTypesMap = {
  pap: 1,
  kap: 2,
};

export const receiptTypesMap = {
  kpo: 1,
  ppk: 2,
  kac: 3,
  kio: 4,
};

export const reversedReceiptTypesMap = {
  1: 'kpo',
  2: 'ppk',
  3: 'kac',
  4: 'kio',
};

export const paymentTypesMap = {
  transfer: 1,
  cash: 2,
  refund: 3,
  other: 4,
};

export const paymentReceivedTypesMap = {
  cash: 1,
  transfer: 2,
};

export const discountTypesMap = {
  percent: 1,
  fixed: 2,
};

export const invoiceTypesMap = {
  simple: 1,
  advance: 2,
  credit: 3,
};
export const expenseTypesMap = {
  simple: 1,
  vatSimple: 2,
  credit: 3,
  invoice: 4,
  receipt: 5,
  other: 6,
  vatCredit: 7,
};

export const fixedAssetStatusTypesMap = {
  worn_out: 1,
  not_worn_out: 2,
};

export const seriesTypesMap = {
  simple: 1,
  advance: 2,
  credit: 3,
  kpo: 4,
  ppk: 5,
  kio: 6,
  simpleWaybill: 7,
  cmrWaybill: 8,
  internalWaybill: 16,
  project: 19,
};

export const waybillsTypeMap = {
  simpleWaybill: 1,
  cmrWaybill: 2,
  internalWaybill: 3,
};

export const waybillInternalWarehouseTypeMap = {
  sender: 1,
  receiver: 2,
};

export const waybillTypeFilterTypesMap = {
  simple: 'simple',
  cmr: 'cmr',
  internal: 'internal',
  nullified: 'nullified',
};


export const contactTypesMap = {
  simple: 1,
  cashier: 2,
  accountant: 3,
};

export const expenseTypeCategoriesMap = {
  goods: 1,
  fixedAsset: 2,
  taxes: 3,
};

export const invoiceStatusFilterTypesMap = {
  paid: 'paid',
  overpaid: 'overpaid',
  partially_paid: 'partially_paid',
  cash: 'cash',
  transfer: 'transfer',
  unpaid: 'unpaid',
  fully_unpaid: 'fully_unpaid',
  late: 'late',
};

export const invoiceTypeFilterTypesMap = {
  draft: 'draft',
  eskola: 'eskola',
  nullified: 'nullified',
  simple: 'simple',
  advance: 'advance',
  no_project: 'no_project',
  credit: 'credit',
};

export const invoiceSortTypesMap = {
  client_debt_asc: 'client_debt_asc',
  client_debt_desc: 'client_debt_desc',
};

export const periodicInvoicesStatusMap = {
  active: 'active',
  halted: 'halted',
  archived: 'archived',
  nullified: 'nullified',
};

export const periodicInvoiceStatusEnum = {
  active: 1,
  halted: 2,
  archived: 3,
};

export const paymentStatusTypesMap = {
  pending: 1,
  canceled: 2,
  paid: 3,
  error: 4,
};

export const paymentStatusToNameMap = {
  1: 'pending',
  2: 'canceled',
  3: 'paid',
  4: 'error',
};

export const stripePaymentStatusTypesMap = {
  incomplete: 'incomplete',
  active: 'active',
  canceled: 'canceled',
  unpaid: 'unpaid',
};

export const sipStatusTypesMap = {
  pending: 1,
  canceled: 2,
  signed: 3,
  error: 4,
  expired: 5,
};

export const expenseStatusFilterTypesMap = {
  paid: 'paid',
  partially_paid: 'partially_paid',
  unpaid: 'unpaid',
  late: 'late',
  nullified: 'nullified',
  simple: 'simple',
  'vat-simple': 'vat-simple',
  credit: 'credit',
  'vat-credit': 'vat-credit',
  invoice: 'invoice',
  receipt: 'receipt',
};

export const expenseDocumentStatusFilterTypesMap = {
  exported: 'exported',
  not_exported: 'not_exported',
};

export const purchaseStatusFilterTypesMap = {
  paid: 'paid',
  partially_paid: 'partially_paid',
  unpaid: 'unpaid',
  late: 'late',
  nullified: 'nullified',
  purchase: 'purchase',
  advance_purchase: 'advance_purchase',
  credit: 'credit',
};

export const fixedAssetStatusFilterTypesMap = {
  worn_out: 'worn_out',
  not_worn_out: 'not_worn_out',
};

export const subscriptionPaymentTypesMap = {
  online: 'online',
  manual: 'manual',
  recurring: 'recurring',
};

export const subscriptionTypesMap = {
  free: 'free',
  mini: 'mini',
  single: 'single',
  business: 'business',
};

export const receiptStatusFilterTypesMap = {
  kpo: '1',
  ppk: '2',
  kac: '3',
  kio: '4',
};

export const warehouseCategoryStatusFilterTypesMap = {
  valid: 'valid',
  expired: 'expired',
};

export const companyTypes = {
  joint_stock: 1,
  association: 2,
  individual_company: 3,
  individual_activity: 4,
  individual_activity_with_license: 5,
  small_community: 6,
  limited_liability_company: 7,
  public_institution: 8,
  other: 9,
};

export const inverseTypesMap = {
  1: 95,
  2: 96,
};

export const periodTypesMap = {
  day: 1,
  week: 2,
  month: 3,
  year: 4,
};

export const templateTypesMap = {
  email: 1,
  invoice: 2,
  reminder: 3,
};

export const warehousePurchaseTypesMap = {
  purchase: 1,
  advance_purchase: 2,
  credit: 3,
};

export const warehouseStatuses = {
  active: 1,
  inactive: 2,
};

export const exportStatusTypesMap = {
  pending: 1,
  failed: 2,
  completed: 3,
};

export const periodNamesMap = {
  [periodTypesMap.day]: 'day',
  [periodTypesMap.week]: 'week',
  [periodTypesMap.month]: 'month',
  [periodTypesMap.year]: 'year',
};


export const inverseVatsMap = {
  inverse_vat_95: 1,
  inverse_vat_96: 2,
};

export const freeFormDocTypesMap = {
  goods_acceptance_transfer: 1,
  services_acceptance_transfer: 2,
  free_form: 3,
  commercial_offer: 4,
  packing_slip: 5,
};

export const commercialSuggestionStatusMap = {
  sent: 1,
  accepted: 2,
  declined: 3,
};

export const commercialSuggestionStatusFilterTypesMap = {
  draft: 'draft',
  sent: 'sent',
  not_sent: 'not_sent',
  accepted: 'accepted',
  declined: 'declined',
  archived: 'archived',
  nullified: 'nullified',
};

export const commercialSuggestionStatusFilterEventsTypesMap = {
  accepted: 'accepted',
  declined: 'declined',
  archived: 'archived',
  nullified: 'nullified',
};

export const companyContractStatusFilterTypesMap = {
  unsigned: 'unsigned',
  signed: 'signed',
  expired: 'expired',
  cancelled: 'cancelled',
  nullified: 'nullified',
  archived: 'archived',
};

export const companyContractPaymentTypeFilterTypesMap = {
  fixed: 'fixed',
  periodic: 'periodic',
  advance: 'advance',
};

export const companyContractPaymentHasInvoiceFilterTypesMap = {
  yes: 'yes',
  no: 'no',
};

export const companyContractPaymentInvoiceStatusFilterTypesMap = {
  paid: 'paid',
  partly_paid: 'partly_paid',
  unpaid: 'unpaid',
  overpaid: 'overpaid',
};

export const dashboardIntervalTypesMap = {
  year: 'year',
  last_6_months: 'last_6_months',
  last_12_months: 'last_12_months',
};

export const companyContractPaymentTypesMap = {
  simple: 1,
  periodic: 2,
};

export const twoFactorTypesMap = {
  topt: 1,
  email: 2,
  sms: 3,
};

export const rivileClientCodeTypesMap = {
  hashed: 1,
  increment: 2,
  custom: 3,
};

export const productManufacturingTypesMap = {
  used_product: 1,
  manufactured_product: 2,
};

export const warehouseValueTypesMap = {
  prime_price: 1,
  selling_price: 2,
};

export const workActTypesMap = {
  completed_work_act: 1,
  goods_write_off_act: 2,
};

export const workActTypesStatusFilterMap = {
  nullified: 'nullified',
};

export const productStatusFilterTypesMap = {
  nullified: 'nullified',
};

export const tagTypesMap = {
  invoice: 1,
  expense: 2,
  commercialSuggestion: 3,
  act: 4,
};

export const projectStatusesMap = {
  not_started: 1,
  in_progress: 2,
  completed: 3,
  archived: 4,
};

export const emailReceiverStatusMap = {
  pending: 1,
  sent: 2,
  error: 3,
};

export const reportTypesMap = {
  invoices: 'invoices',
  sold_products: 'sold_products',
  clients_sales: 'clients_sales',
  expenses_groups: 'expenses_groups',
};

export const pdfTemplateTypesMap = {
  invoice_modern: 1,
  invoice_minimalistic: 3,
  invoice_detailed: 5,
  commercial_modern: 2,
  commercial_minimalistic: 4,
  commercial_detailed: 6,
};

export const importPricesTypesMap = {
  total_price: 1,
  unit_price: 2,
};

export const extraEmailSettingTypesMap = {
  invoice_simple: 1,
  invoice_advance: 2,
  invoice_credit: 3,
  invoice_reminder: 4,
  all: 5,
};

export const documentProcessingStatusMap = {
  pending: 1,
  success: 2,
  failed: 3,
};

export const invoiceMassActionTypeMap = {
  set_paid: 1,
  export: 2,
  nullify: 3,
  add_tags: 4,
};

export const expenseMassActionTypeMap = {
  set_paid: 1,
  export: 2,
  nullify: 3,
};

export const filterTypesMap = {
  invoice: 1,
  client: 2,
  expense: 3,
  commercialSuggestion: 4,
  workAct: 5,
  purchase: 6,
  waybill: 7,
  warehouseCategory: 8,
  fixedAsset: 9,
  periodicInvoice: 10,
  periodicExpense: 11,
  reports: 12,
  project: 13,
  product: 14,
  receipt: 15,
  expenseDocument: 16,
  contract: 17,
  contractPayment: 18,
  sipPayment: 19,
  sipExpense: 20,
  emails: 21,
};

export const ocrClientSourceMap = {
  ocr: 'ocr',
  okredo: 'okredo',
};

export const projectListLayoutMap = {
  list: 1,
  board: 2,
};

export const finvaldaProductExportTypeMap = {
  goods: 0,
  service: 1,
};

export const productTypesMap = {
  goods: 1,
  service: 2,
};

export const pragmaCorrespondenceMappingTypeMap = {
  vatCode: 1,
  country: 2,
};

export const subscriptionUpdateTypesMap = {
  upgrade: 1,
  downgrade: 2,
  restore: 3,
};

export const savedFiltersVisibilityTypesMap = {
  personal: 1,
  team: 2,
};

